import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-help-info-list',
    templateUrl: './help-info-list.component.html',
    styleUrls: ['./help-info-list.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                display: 'none', opacity: '0',
            })),
            state('block', style({
                display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('80ms linear'))
        ])
    ]
})
export class HelpInfoListComponent implements OnInit {
    changeOpen: Boolean = false;
    @Input() ecpTheme: 'default' | 'white' | 'gw-green' = 'default';

    constructor() {
    }

    ngOnInit() {
    }

}
